// extracted by mini-css-extract-plugin
module.exports = {"portal_viewport":"index-module_portal_viewport_2R9f0","inner_dialog":"index-module_inner_dialog_22ZiI","tooltip_style":"index-module_tooltip_style_oiiXw"};